import CustomerId               from "../../../../domain/customer/CustomerId";
import FetchStatusRepository    from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository         from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import CurrentPage              from "../../../../domain/fundamentals/pagination/CurrentPage";
import CustomerRecordId         from "../../../../domain/record/customer/CustomerRecordId";
import CustomerRecordRepository from "../../../../domain/record/customer/CustomerRecordRepository";
import FetchStatusDataSource    from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource         from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import CustomerRecordDataSource from "../../../../infrastructure/datasource/record/customer/CustomerRecordDataSource";
import RouterDispatcher         from "../../../../infrastructure/redux/router/RouterDispatcher";
import GetCustomerRecords       from "./GetCustomerRecords";

class DeleteCustomerRecord {
  private readonly repository: CustomerRecordRepository = new CustomerRecordDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);
  private readonly getCustomerRecords: GetCustomerRecords = new GetCustomerRecords(this.dispatch);
  private readonly routerDispatcher: RouterDispatcher = new RouterDispatcher(this.dispatch);
  constructor(private readonly dispatch) {}

  public async execute(customerId: CustomerId, customerRecordId: CustomerRecordId) {
    this.fetchStatusRepository.start();
    try {
      await this.repository.delete(customerRecordId);
      await this.getCustomerRecords.execute(customerId, new CurrentPage(1));
      this.notifyRepository.deleteSuccess();
      this.routerDispatcher.customerRecords();
    } catch (e) {
      this.notifyRepository.deleteFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default DeleteCustomerRecord;
